export default "__VITE_ASSET__eiOt_cDn__";